module.exports = __webpack_public_path__ + "img/close.5c236708.svg";